/**
 * @generated SignedSource<<5993d6386b0eec6a0c23add788764bb6>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addMoqRulePanel_MoqRulesListQuery$variables = Record<PropertyKey, never>;
export type addMoqRulePanel_MoqRulesListQuery$data = {
  readonly moqRules: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly globalColors: ReadonlyArray<string>;
        readonly id: string;
        readonly moqRuleID: number;
        readonly name: string;
        readonly printTypes: ReadonlyArray<{
          readonly printTypeID: number;
        }>;
      };
    }> | null;
  } | null;
};
export type addMoqRulePanel_MoqRulesListQuery = {
  response: addMoqRulePanel_MoqRulesListQuery$data;
  variables: addMoqRulePanel_MoqRulesListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 200
      }
    ],
    "concreteType": "MoqRulesConnection",
    "kind": "LinkedField",
    "name": "moqRules",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MoqRulesEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MoqRule",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "moqRuleID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MoqRulePrintType",
                "kind": "LinkedField",
                "name": "printTypes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "printTypeID",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "globalColors",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "moqRules(first:200)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "addMoqRulePanel_MoqRulesListQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "addMoqRulePanel_MoqRulesListQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "2013d03b753756ea732ab6bfcc970f69",
    "id": null,
    "metadata": {},
    "name": "addMoqRulePanel_MoqRulesListQuery",
    "operationKind": "query",
    "text": "query addMoqRulePanel_MoqRulesListQuery {\n  moqRules(first: 200) {\n    edges {\n      node {\n        id\n        moqRuleID\n        name\n        printTypes {\n          printTypeID\n        }\n        globalColors\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6c6b159c36e8e18a0bd15196829cf55f";

export default node;
